<template>
  <div class="box">
    <ApexChart
      width="99%"
      height="160"
      type="area"
      :options="chartOptions"
      :series="chartSeries"
    />
    <BLoading
      :active.sync="loading"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('statistics');

const genChartOptions = (text, labels) => ({
  chart: {
    id: 'DashboardStatisticsSalesYear',
    height: '250px',
    type: 'area',
    sparkline: { enabled: false },
    toolbar: { show: false },
  },
  toolbar: { show: false },
  stroke: { curve: 'straight' },
  fill: { opposite: 1 },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      show: true,
      align: 'left',
      style: {
        fontSize: '8px',
      },
    },
  },
  xaxis: {
    type: 'dateTime',
    categories: labels,
    labels: {
      show: false,
      align: 'left',
      style: {
        fontSize: '8px',
      },
      rotate: -90,
      rotateAlways: true,
    },
    tooltip: {
      enabled: false,
    },
  },
  axisTicks: { show: false },
  colors: ['#0BA23B', '#306A9B'],
  title: {
    text,
    offsetX: 30,
    style: { fontSize: '24px', cssClass: 'apexcharts-yaxis-title' },
  },
  subtitle: {
    text: 'Ventas en el año',
    offsetX: 30,
    style: { fontSize: '14px', cssClass: 'apexcharts-yaxis-title' },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
});

export default {
  name: 'DashboardStatisticsSalesYear',
  data() { return { loading: false }; },
  computed: merge(
    mapState({ sales: ({ salesYear }) => salesYear }),
    mapGetters([
      'sumSalesYearTotalCurrency',
      'salesYearLabels',
      'salesYearSeries',
      'salesYearTotalCurrencyNonFiscal',
      'salesYearLabelsNonFiscal',
      'salesYearSeriesNonFiscal',
    ]),
    {
      chartOptions() {
        if (this.salesYearLabels.length > 1) {
          return genChartOptions(this.sumSalesYearTotalCurrency, this.salesYearLabels);
        }

        const date = moment({ d: 0, h: 0, m: 0 }).subtract(1, 'month');
        const labels = [date.format('YYYY-MM'), ...this.salesYearLabels];

        return genChartOptions(this.sumSalesYearTotalCurrency, labels);
      },
      chartSeries() {
        if (this.salesYearSeries.length > 1) {
          return [
            { name: 'Fiscal', data: this.salesYearSeries },
            { name: 'No Fiscal', data: this.salesYearSeriesNonFiscal },
          ];
        }

        return [
          { name: 'Fiscal', data: [0, ...this.salesYearSeries] },
          { name: 'No Fiscal', data: [0, ...this.salesYearSeriesNonFiscal] },
        ];
      },
    },
  ),
  async beforeMount() {
    this.loading = true;

    await this.getSales({ year: (new Date()).getFullYear() });

    this.loading = false;
  },
  methods: merge(mapActions(['getSales'])),
};
</script>

<style scoped>
</style>
